var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5781 7.62578L7.675 2.50234C7.62969 2.46328 7.57188 2.44141 7.51094 2.44141H6.12813C6.0125 2.44141 5.95937 2.58516 6.04688 2.66016L11.5188 7.41016H2.375C2.30625 7.41016 2.25 7.46641 2.25 7.53516V8.47266C2.25 8.54141 2.30625 8.59766 2.375 8.59766H11.5172L6.04531 13.3477C5.95781 13.4242 6.01094 13.5664 6.12656 13.5664H7.55625C7.58594 13.5664 7.61562 13.5555 7.6375 13.5352L13.5781 8.38203C13.6322 8.33499 13.6756 8.2769 13.7053 8.21167C13.735 8.14644 13.7504 8.07559 13.7504 8.00391C13.7504 7.93222 13.735 7.86138 13.7053 7.79614C13.6756 7.73091 13.6322 7.67282 13.5781 7.62578Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.30076aeda8a6aa6246b4cf2af957950d.svg";
export { ForwardRef as ReactComponent };